<template>
  <div id="UserDetailsAdmin">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>{{user.name}}'s</span>
            </h1>
            <div class="page-header-subtitle">Account Details</div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <div class="card-body">
                <table class="table table-bordered">
                  <tr>
                    <th>Name</th>
                    <td>{{user.name}}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{{user.email}}</td>
                  </tr>
                  <tr>
                    <th>Phone</th>
                    <td>{{user.phone}}</td>
                  </tr>
                  <tr>
                    <th>Role</th>
                    <td>
                      <span v-if="user.role.slug === 'admin'">Admin</span>
                      <span v-if="user.role.slug === 'agent'">{{client.agentLabel}}</span>
                      <span v-if="user.role.slug === 'supervisor'">{{client.supervisorLabel}}</span>
                    </td>
                  </tr>

                  <tr v-if="user.role.slug==='supervisor'">
                    <th>{{client.topCategoryLabel}}</th>
                    <td>
                      <ul>
                        <li v-for="(cat,index) in user.categories" :key="cat.uuid">
                          {{cat.name}}
                          <span @click="unassign(cat.uuid, 'supervisor', index)" class="text-danger" style="font-size:12px; cursor:pointer">[unassign]</span>
                        </li>
                      </ul>
                      <router-link :to="{name:'AssignSupervisorAdmin', params:{uuid:this.$route.params.uuid}}">Assign to {{client.topCategoryLabel}}</router-link>
                    </td>
                  </tr>
                  <tr v-if="user.role.slug==='agent'">
                    <th>{{client.subCategoryLabel}}</th>
                    <td>
                      <ul v-show="user.subCategories.length > 0">
                        <li v-for="(cat,index) in user.subCategories" :key="cat.uuid">
                          {{cat.name}}
                          <span @click="unassign(cat.uuid, 'agent', index)" class="text-danger" style="font-size:12px; cursor:pointer">[unassign]</span>
                          <span style="font-size:11px; display:block; margin-bottom:7px">{{cat.category.name}}</span>
                        </li>
                      </ul>
                      <router-link :to="{name:'AssignAgentAdmin', params:{uuid:this.$route.params.uuid}}">Assign to {{client.subCategoryLabel}}</router-link>
                    </td>
                  </tr>
                  <tr>
                    <th>Created Date/Time</th>
                    <td>{{user.createdAt | formatDateTime}}</td>
                  </tr>
                </table>
                <router-link :to="{name:'EditUserAdmin', params: {uuid: this.$route.params.uuid}}" class="btn btn-outline-secondary btn-xs">edit</router-link>
                <button @click="deleteUser" class="btn btn-outline-secondary btn-xs ml-3">delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>


<script>
import axios from "axios";

export default {
  name: "UserDetailsAdmin",

  data() {
    return {
      user: { role: {} },
    };
  },

  mounted() {
    let loading = this.$loading.show();
    axios.get(`/admin/user/${this.$route.params.uuid}`).then((res) => {
      this.user = res.data.user;
      loading.hide();
    });
  },

  methods: {
    deleteUser() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: `DELETE: ${this.user.name}'s account`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            /* actural action */
            let loading = this.$loading.show();

            axios.post(`/admin/user/delete/${this.user.uuid}`).then((res) => {
              if (res.data.status == "success") {
                this.$swal.fire("Deleted!", `${this.user.name} deleted`, "success");
                this.$router.push({ name: "UsersAdmin", params: { role: this.user.role.slug } });
              } else {
                this.$swal("", res.data.message, "error");
              }
              loading.hide();
            });
            /* end of actural action */
          }
        });
    },

    unassign(uuid, role, index) {
      this.$swal
        .fire({
          text: "Please confirm un-assigning user",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, confirmed",
        })
        .then((result) => {
          if (result.value) {
            /* actural action */
            let loading = this.$loading.show();
            let formData = new FormData();
            formData.append("userUUID", this.$route.params.uuid);
            formData.append("categoryUUID", uuid);
            axios.post(`/admin/assign-un${role}`, formData).then((res) => {
              //console.log(res.data);
              if (res.data.status == "success") {
                if (role === "agent") {
                  this.user.subCategories.splice(index, 1);
                } else if (role === "supervisor") {
                  this.user.categories.splice(index, 1);
                }
                this.$swal("", res.data.message, "success");
              } else {
                this.$swal("", res.data.message, "error");
              }

              loading.hide();
            });
            /* end of actural action */
          }
        });
    },
  },

  computed: {
    client() {
      return this.$store.state.client;
    },
  },

  created() {
    //this.$store.commit("SET_LAYOUT", "agent-layout");
  },
};
</script>

